// extracted by mini-css-extract-plugin
export default {"checkbox":"FilterCheckbox_checkbox__9Awfg","square":"FilterCheckbox_square__1Qxhc"};